export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/d3-shape/src/identity.js
// module id = 3788
// module chunks = 0